import React from 'react';
import { X, Loader2 } from 'lucide-react';

const Modal = ({ 
    isOpen, 
    onClose, 
    title, 
    children, 
    confirmText, 
    onConfirm, 
    size = "max-w-lg", 
    icon: Icon,
    isLoading = false,
    hideFooter = false
}) => {
    
    if (!isOpen) return null;

    const handleConfirm = onConfirm ? onConfirm : null;

    return (
        <div 
            className="fixed inset-0 bg-gray-900 bg-opacity-80 flex items-center justify-center z-50 p-4 backdrop-blur-sm animate-in fade-in duration-200"
            onClick={onClose} 
        >
            {/* MUDANÇA AQUI: 
               1. Definimos uma altura fixa máxima (h-[90vh]).
               2. Usamos 'flex flex-col' para organizar o cabeçalho, corpo e rodapé verticalmente.
            */}
            <div 
                className={`bg-white rounded-xl shadow-2xl ${size} w-full relative flex flex-col h-[90vh] max-h-[90vh]`}
                onClick={(e) => e.stopPropagation()} 
            >
                {/* Botão X (Sem alterações) */}
                <button 
                    onClick={onClose} 
                    className="absolute top-4 right-4 text-gray-400 hover:text-red-500 hover:bg-red-50 p-2 rounded-full transition-colors z-10"
                    title="Fechar Janela"
                    disabled={isLoading}
                >
                    <X className="w-6 h-6" />
                </button>

                {/* Cabeçalho (Sem alterações, altura automática) */}
                <div className="flex items-center px-6 py-4 border-b border-gray-100 pr-14 flex-shrink-0"> 
                    {Icon && (
                        <div className="mr-3 text-blue-600 bg-blue-50 p-2 rounded-lg">
                            {Icon}
                        </div>
                    )}
                    <h3 className="text-xl font-bold text-gray-800 leading-tight">{title}</h3>
                </div>
                
                {/* CORPO DO MODAL (MUDANÇA CRÍTICA):
                    1. 'flex-1': Ocupa todo o espaço vertical disponível entre o cabeçalho e o rodapé.
                    2. 'overflow-hidden':  IMPEDE que este container crie uma barra de rolagem. 
                       A responsabilidade da rolagem passa para o elemento filho (children).
                    3. 'p-6': Padding interno.
                */}
                <div className="flex-1 overflow-hidden p-6 relative">
                    {children}
                </div>
                
                {/* Rodapé */}
                {!hideFooter && (
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-100 flex flex-col-reverse sm:flex-row sm:justify-end gap-3 rounded-b-xl flex-shrink-0">
                    
                    <button
                        type="button"
                        onClick={onClose}
                        disabled={isLoading} 
                        className="inline-flex justify-center items-center rounded-lg border border-transparent shadow-sm px-5 py-2.5 bg-orange-500 text-sm font-semibold text-white hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                    >
                        Fechar
                    </button>

                    {handleConfirm && (
                        <button
                            type="button"
                            disabled={isLoading}
                            onClick={isLoading ? () => {} : handleConfirm}
                            className={`inline-flex justify-center items-center rounded-lg border border-transparent shadow-sm px-5 py-2.5 bg-blue-600 text-sm font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all
                                      ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
                        >
                            {isLoading ? (
                                <>
                                    <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                                    Processando...
                                </>
                            ) : (
                                confirmText || 'Confirmar'
                            )}
                        </button>
                    )}
                </div>
                )}
            </div>
        </div>
    );
};

export default Modal;